(() => {
  'use strict';
  const mount = (root = document) => {
    root.querySelectorAll?.('[data-wub-expandable-text]').forEach((host) => {
      if (host.dataset.wubExpandableReady === 'true') return;
      host.dataset.wubExpandableReady = 'true';
      const content = host.querySelector('[data-wub-expandable-content]');
      const toggle = host.querySelector('[data-wub-expandable-toggle]');
      if (!content || !toggle) return;
      const max = Math.max(0, parseInt(host.dataset.maxHeight || '0', 10));
      const sync = () => {
        const needsToggle = max > 0 && content.scrollHeight > max;
        host.classList.toggle('max-height--active', needsToggle);
        if (!needsToggle) host.classList.remove('max-height--enabled');
        toggle.setAttribute('aria-expanded', host.classList.contains('max-height--enabled') ? 'true' : 'false');
      };
      toggle.addEventListener('click', () => {
        if (!host.classList.contains('max-height--active')) return;
        host.classList.toggle('max-height--enabled');
        toggle.setAttribute('aria-expanded', host.classList.contains('max-height--enabled') ? 'true' : 'false');
      });
      sync();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(sync);
        observer.observe(content);
      } else {
        window.addEventListener('resize', sync, { passive: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
  document.addEventListener('shopify:section:load', (event) => mount(event.target));
})();
